import { takeLatest, call, put } from 'redux-saga/effects';
import memberAdminApi from 'api/employee/memberAdminApi';
import portalApi from 'api/others/portalApi';
import * as passwordChangeActions from 'redux/ducks/personalInformation/passwordChangeDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';

let utoken;

export function* getCheckPassword({ payload }) {
  try {
    const res_utoken = yield call(portalApi.getEncodeUserToken);
    utoken = `JWT ${res_utoken.text}`;
    const response = yield call(memberAdminApi.getCheckPassword, payload, utoken);
    if (response) {
      yield put(passwordChangeActions.getCheckPasswordSuccess(response));
    } else {
      yield put(passwordChangeActions.getCheckPasswordFail());
      yield put(alertActions.open({ message: ['MB_M_NOT_MATCH_CURRENTPWD'] }));
    }
  } catch (error) {
    utoken = null;
    yield put(passwordChangeActions.getCheckPasswordFail());
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* modifyPassword({ payload }) {
  try {
    const response = yield call(memberAdminApi.modifyPassword, payload, utoken);
    yield put(passwordChangeActions.modifyPasswordSuccess(response));
    yield put(
      alertActions.open({
        message: ['MB_M_SUCCESS_MODIFY'],
        callback: () => {
          window.location.reload();
        },
      }),
    );
    utoken = null;
  } catch (error) {
    utoken = null;
    yield put(passwordChangeActions.modifyPasswordFail());
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* modifyPasswordKms({ payload }) {
  try {
    const response = yield call(memberAdminApi.modifyPasswordKms, payload, utoken);
    yield put(passwordChangeActions.modifyPasswordSuccess(response));
    yield put(
      alertActions.open({
        message: ['MB_M_SUCCESS_MODIFY'],
        callback: () => {
          window.location.reload();
        },
      }),
    );
    utoken = null;
  } catch (error) {
    utoken = null;
    yield put(passwordChangeActions.modifyPasswordFail());
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* modifyPasswordInitial({ payload }) {
  try {
    const response = yield call(memberAdminApi.modifyPasswordInitial, payload);
    yield put(passwordChangeActions.modifyPasswordSuccess(response));
    yield put(
      alertActions.open({
        message: ['MB_M_SUCCESS_MODIFY'],
        callback: () => {
          window.location.reload();
        },
      }),
    );
    utoken = null;
  } catch (error) {
    utoken = null;
    yield put(passwordChangeActions.modifyPasswordFail());
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export default function* passwordChangeSaga() {
  yield takeLatest(passwordChangeActions.getCheckPassword, getCheckPassword);
  yield takeLatest(passwordChangeActions.modifyPassword, modifyPassword);
  yield takeLatest(passwordChangeActions.modifyPasswordKms, modifyPasswordKms);
  yield takeLatest(passwordChangeActions.modifyPasswordInitial, modifyPasswordInitial);
}
